const CheckCircleIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 21'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.0525 3.64451C11.5752 2.98627 9.92468 2.8232 8.34712 3.17962C6.76957 3.53605 5.3495 4.39288 4.29869 5.62232C3.24789 6.85176 2.62265 8.38794 2.51624 10.0017C2.40982 11.6156 2.82793 13.2205 3.7082 14.5773C4.58847 15.9341 5.88374 16.97 7.40083 17.5305C8.91792 18.0909 10.5756 18.146 12.1265 17.6874C13.6774 17.2289 15.0386 16.2812 16.007 14.9859C16.9754 13.6905 17.4991 12.1168 17.5 10.4995V9.73332C17.5 9.27309 17.8731 8.89999 18.3333 8.89999C18.7936 8.89999 19.1667 9.27309 19.1667 9.73332V10.5C19.1655 12.4767 18.5254 14.4006 17.3419 15.9838C16.1583 17.567 14.4947 18.7252 12.5991 19.2857C10.7035 19.8462 8.67747 19.7789 6.82324 19.0938C4.96902 18.4088 3.38591 17.1427 2.31003 15.4844C1.23414 13.8262 0.723122 11.8645 0.853183 9.89209C0.983245 7.91965 1.74742 6.0421 3.03174 4.53945C4.31605 3.0368 6.0517 1.98957 7.97982 1.55393C9.90794 1.1183 11.9252 1.31761 13.7308 2.12213C14.1512 2.30945 14.3402 2.8021 14.1528 3.22249C13.9655 3.64288 13.4729 3.83183 13.0525 3.64451Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M18.9223 3.24378C19.2479 3.56906 19.2481 4.09669 18.9229 4.42229L10.5895 12.764C10.4333 12.9204 10.2213 13.0083 10.0002 13.0083C9.77911 13.0084 9.56707 12.9206 9.41073 12.7643L6.91073 10.2643C6.5853 9.93882 6.5853 9.41118 6.91073 9.08574C7.23617 8.76031 7.76381 8.76031 8.08925 9.08574L9.99969 10.9962L17.7438 3.24437C18.069 2.91877 18.5967 2.91851 18.9223 3.24378Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
};

export default CheckCircleIcon;
